import { get } from './requests'

export const getBusinessFronts = key => get(['business-front'], { key })
export const getUserAgencyFlows = key => get(['business-front', 'user-agency-flows'], { key })
